<div class="tcf">
  <header class="tcf-header">
    <h2>Edit user</h2>
  </header>

  <div class="tcf-body" [formGroup]="form">
    <label class="field">
      <span class="field-label">Email address <em>*</em></span>
      <input type="email" formControlName="emailAddress" />
      <span class="field-error" *ngIf="form.get('emailAddress')?.touched && form.get('emailAddress')?.hasError('required')">Required</span>
      <span class="field-error" *ngIf="form.get('emailAddress')?.hasError('email')">Invalid email</span>
    </label>

    <label class="field">
      <span class="field-label">Display name (optional)</span>
      <input type="text" formControlName="displayName" />
    </label>

    <label class="field">
      <span class="field-label">Username — alternate login (optional)</span>
      <input type="text" formControlName="userName" />
    </label>

    <label class="check-row">
      <input type="checkbox" formControlName="canLogin" />
      <span>Account can sign in</span>
    </label>

    <p class="tcf-error" *ngIf="error">{{ error }}</p>
  </div>

  <footer class="tcf-actions">
    <button type="button" class="br-btn br-btn--ghost" (click)="cancel()">Cancel</button>
    <button type="button" class="br-btn br-btn--primary" [disabled]="form.invalid || submitting" (click)="submit()">
      {{ submitting ? 'Saving…' : 'Save' }}
    </button>
  </footer>
</div>
